<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <v-card class="px-4">
      <v-card-text class="pa-7" style="position: relative">
        <div
          v-if="clearable"
          class="text-h4 cursor"
          style="position: absolute; right: 0px; top: 15px"
          variant="flat"
          @click="dialog = false"
        >
          <i class="fa-solid fa-circle-xmark" style="color: #ff6f00"></i>
        </div>
        <div>
          <div
            class="py-0 mb-3 d-flex justify-content-start align-center text-h5 pr-3 font-weight-bold"
            dense
            tile
            elevation="0"
            :class="`${titleClass}`"
          >
            {{ title }}
          </div>
          <p class="text-h6 mb-6" v-html="content" style="color: #000"></p>
          <v-btn
            v-if="showTimeoutBtn"
            class="d-flex flex-column justify-end px-4"
            color="#FF6F00"
            style="
              border-radius: 11px;
              width: 145px;
              font-size: 20px;
              height: 34px;
              margin: 0 auto;
            "
            dark
            label
            @click="refreshPage"
            >重整
          </v-btn>
          <v-btn
            v-else
            class="d-flex flex-column justify-end px-4"
            color="#FF6F00"
            style="
              border-radius: 11px;
              width: 145px;
              font-size: 20px;
              height: 34px;
              margin: 0 auto;
            "
            dark
            label
            @click="dialog = false"
            >{{ confirmButtonText }}
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "GlobalDialog",
  created() {
    this.$dialog.show = this.show;
  },
  data() {
    return {
      dialog: false,
      color: "",
      title: "",
      titleClass: "",
      content: "",
      confirmButtonText: "",
      cancelable: false,
      resolve: "",
      reject: "",
      showTimeoutBtn: false,
      clearable: true,
    };
  },
  methods: {
    show(content, userOption) {
      let option = {
        // color: "grey lighten-2",
        title: "錯誤訊息",
        titleClass: "red--text text--darken-3",
        cancelable: false,
        confirmButtonText: "確定",
        clearable: true,
        ...userOption,
      };
      if (content.includes("Request timeout")) {
        this.showTimeoutBtn = true;
      }
      this.content = content;
      this.color = option.color;
      this.title = option.title;
      this.titleClass = option.titleClass;
      this.cancelable = option.cancelable;
      this.confirmButtonText = option.confirmButtonText;
      this.clearable = option.clearable;
      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    confirm() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
    refreshPage() {
      window.location.reload();
    },
  },
};
</script>
